<template>
  <div
    v-if="showPaginator"
    :class="{ 'top-paginator': topPaginator }"
    class="justify-content-center align-items-center search-paginator-container"
  >
    <div class="d-flex text-center">
      <div class="button-container prev">
        <Button
          :font-color="hasPrevPage ? '' : '#e3e3e3'"
          :enabled="hasPrevPage"
          shape="outline-hover"
          size="tiny"
          :border-color="borderColor"
          :to="prevPageLink"
          :use-nuxt-link="useNuxtLink"
          :extra-data="{ 'aria-label': $t('common.paginator.sector.button') }"
          @click="prevPage($event)"
        >
          <div class="d-flex align-items-center">
            <Icon icon="bootstrap-chevron-left" :width="14" :height="14" />
          </div>
        </Button>
      </div>
      <div class="d-flex align-items-center input-text">
        <label class="m-0">
          <input
            type="number"
            :value="currentPage"
            class="input-page"
            @keyup.enter="changePage($event)"
          />
        </label>
      </div>
      <div class="button-container next">
        <Button
          :font-color="hasNextPage ? '' : '#e3e3e3'"
          :enabled="hasNextPage"
          shape="outline-hover"
          size="tiny"
          :border-color="borderColor"
          :to="nextPageLink"
          :use-nuxt-link="useNuxtLink"
          :extra-data="{ 'aria-label': $t('common.paginator.sector.button2') }"
          @click="nextPage($event)"
        >
          <div class="d-flex align-items-center">
            <Icon icon="bootstrap-chevron-right" :width="14" :height="14" />
          </div>
        </Button>
      </div>
      <p class="pages-text">{{ $t('common.paginator.sector.text2') }} {{ totalPages }}</p>
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
import Button from 'UI/Button';
import { mapGetters } from 'vuex';

export default {
  name: 'Paginator',
  components: {
    Button,
    Icon
  },
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    prevPageLink: {
      type: String,
      required: false,
      default: ''
    },
    nextPageLink: {
      type: String,
      required: false,
      default: ''
    },
    currentPage: {
      type: Number,
      required: true
    },
    useNuxtLink: {
      type: Boolean,
      default: true
    },
    topPaginator: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPrevPage() {
      return this.currentPage > 1;
    },
    showPaginator() {
      return this.totalPages > 1;
    },
    borderColor() {
      return this.getExperience || 'default';
    }
  },
  methods: {
    changePage(e) {
      let page = e.target.value;
      page = parseInt(page);
      if (page > this.totalPages) page = this.totalPages;
      if (page < 1) page = 1;
      this.$emit('change-page', page, e);
    },
    nextPage(e) {
      this.$emit('next-page', e);
    },
    prevPage(e) {
      this.$emit('prev-page', e);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-paginator-container {
  display: flex;
  &.top-paginator {
    @include md {
      display: none;
    }
  }
  @include md {
    flex-direction: column;
  }
  .pages-text {
    margin: auto 10px;
    color: #737373;
    font-size: 15px;
  }
}
.right {
  right: 0;
  @include md {
    position: initial !important;
    margin-top: 10px;
  }
}
.left {
  left: 15px;
  @include md {
    position: initial !important;
    margin-top: 10px;
  }
}
.button-container.prev {
  margin-right: 5px;
}
.button-container.next {
  margin-left: 5px;
}
.input-text {
  color: $strongGray;
  font-size: 15px;
  .input-page {
    color: $strongGray;
    width: 28px;
    border-radius: 200%;
    border: 1px $strongGray solid;
    height: 28px;
    text-align: center;
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
